import fromHTML from "../../../../../utilities/fromHTML";
import IconPathMap from "./iconography";

export default function gridPlotSeriesTooltip(
   userTheme,
   seriesConfig,
   series,
   xAxis,
   yAxis,
   categories,
   secondaryCategories,
   palette,
) {
   const boxLabels = ["Min", "Q1", "Median", "Q3", "Max"];
   return {
      trigger: "item",
      backgroundColor: userTheme === "Dark" ? "black" : "white",
      textStyle: {
         color: userTheme === "Dark" ? "white" : "black",
      },
      formatter: function (params) {
         //Create these base divs ahead of time
         const tooltipContainer = document.createElement("div");
         tooltipContainer.setAttribute("class", "tooltip-container");

         const tooltipHeader = document.createElement("div");
         tooltipHeader.setAttribute("class", "tooltip-header");
         tooltipContainer.append(tooltipHeader);

         const tooltipBody = document.createElement("div");
         tooltipBody.setAttribute("class", "tooltip-body");
         tooltipContainer.append(tooltipBody);
         const distinctSeries = series.reduce((acc, val) => {
            if (acc.find((a) => a.name === val.name)) {
               //Cool, already recorded
            } else {
               acc.push(val);
            }
            return acc;
         }, []);
         let icon = seriesConfig.symbol.type
            ? seriesConfig.symbol.type
            : params.seriesType;
         switch (params.seriesType) {
            case "pie":
               tooltipHeader.append(
                  fromHTML(
                     `<span class="big-boy-marker" style="background-color:${params.color}"></span>`,
                  ),
               );
               tooltipBody.append(
                  fromHTML(
                     `<div class="tooltip-row"><p>${params.data.name}</p><p class="tooltip-value">${params.data.value.toFixed(2)}</p></div>`,
                  ),
               );
               break;
            case "heatmap":
               tooltipHeader.append(
                  fromHTML(
                     `<span class="big-boy-marker" style="background-color:${params.color}"></span>`,
                  ),
               );
               tooltipBody.append(
                  fromHTML(
                     `<div class="tooltip-row"><p>${xAxis[seriesConfig.xAxisIndex].name}</p><p class="tooltip-value">${categories[params.data[0]]}</p></div>`,
                  ),
               );
               tooltipBody.append(
                  fromHTML(
                     `<div class="tooltip-row"><p>${yAxis[seriesConfig.yAxisIndex].name}</p><p class="tooltip-value">${secondaryCategories[params.data[1]]}</p></div>`,
                  ),
               );
               tooltipBody.append(
                  fromHTML(
                     `<div class="tooltip-row"><p>Heat Index</p><p class="tooltip-value">${params.data[2].toFixed(2)}</p></div>`,
                  ),
               );
               break;
            case "scatter":
               tooltipHeader.setAttribute(
                  "style",
                  `border-bottom:${palette[distinctSeries.findIndex((d) => d.name === params.seriesName) % palette.length]} 2px solid`,
               );
               tooltipHeader.append(
                  fromHTML(
                     `<div class="tooltip-row"><p>${params.seriesName}</p><svg viewBox="0 0 512 512" height="20" width="20"> <path fill="${palette[distinctSeries.findIndex((d) => d.name === params.seriesName) % palette.length]}" d="${IconPathMap(icon)}"/></svg></div>`,
                  ),
               );
               if (params.data.value.at(3)) {
                  tooltipBody.append(
                     fromHTML(
                        `<div class="tooltip-row"><p>${params.data.value[3].toFixed(2)}</p></div>`,
                     ),
                  );
               }
               tooltipBody.append(
                  fromHTML(
                     `<div class="tooltip-row"><p>${xAxis[seriesConfig.xAxisIndex].name}</p><p class="tooltip-value">${params.data.value[0].toFixed(2)}</p></div>`,
                  ),
               );
               tooltipBody.append(
                  fromHTML(
                     `<div class="tooltip-row"><p>${yAxis[seriesConfig.yAxisIndex].name}</p><p class="tooltip-value">${params.data.value[1].toFixed(2)}</p></div>`,
                  ),
               );
               if (params.data.value.at(2) && params.data.value[2] !== 1) {
                  tooltipBody.append(
                     fromHTML(
                        `<div class="tooltip-row"><p>Magnitude</p><p class="tooltip-value">${params.data.value[2].toFixed(2)}</p></div>`,
                     ),
                  );
               }
               break;
            case "bar":
            // Wrapped "line" case inside of braces to remove ESLint error no-case-declarations.
            case "line": {
               if (seriesConfig.areaStyle && !seriesConfig.symbol.type) {
                  icon = "area";
               }
               const allSeries = series.filter(
                  (t) =>
                     t.yAxisIndex === seriesConfig.yAxisIndex &&
                     t.xAxisIndex === seriesConfig.xAxisIndex &&
                     (t.type === "line" ||
                        t.type === "bar" ||
                        t.type === "area"),
               );
               //figure out which is categorical
               let valueAxis;
               if (yAxis[seriesConfig.yAxisIndex].type === "category") {
                  //uhhh... value/value just relies on x, y order, so can just check y for categorical axis.
                  valueAxis = xAxis[seriesConfig.xAxisIndex];
               } else {
                  valueAxis = yAxis[seriesConfig.yAxisIndex];
               }
               tooltipHeader.append(
                  fromHTML(
                     `<div class="tooltip-row"><p><span class="tooltip-value">${params.name}</span></p><p>${valueAxis.name}</p></div>`,
                  ),
               );

               const colorIndex = distinctSeries.findIndex(
                  (d) => d.name === params.seriesName,
               );
               tooltipHeader.setAttribute(
                  "style",
                  `border-bottom:${palette[colorIndex]} 2px solid`,
               );
               tooltipBody.append(
                  fromHTML(
                     `<div class="tooltip-row">
                                <div class="tooltip-row-identifier">
                                    <svg viewBox="0 0 512 512" height="20" width="20"> <path fill="${palette[colorIndex % palette.length]}" d="${IconPathMap(icon)}"/></svg>
                                    <p>${series[colorIndex].name}</p>
                                </div>
                                <p class="tooltip-value">${params.data.toFixed(2)}</p>
                            </div>`,
                  ),
               );
               if (typeof params.data === "object" && params.data.at(1)) {
                  tooltipBody.append(
                     fromHTML(
                        `<div class="tooltip-row"><p>Magnitude</p><p class="tooltip-value">${params.data[1].toFixed(2)}</p></div>`,
                     ),
                  );
               }

               allSeries.forEach((t) => {
                  const thisColorIndex = distinctSeries.findIndex(
                     (d) => d.name === t.name,
                  );
                  icon = t.type;
                  if (t.areaStyle) {
                     icon = "area";
                  }
                  if (t.name !== params.seriesName) {
                     tooltipBody.append(
                        fromHTML(
                           `<div class="tooltip-row">
                                    <div class="tooltip-row-identifier">
                                        <svg viewBox="0 0 512 512" height="20" width="20"> <path fill="${palette[thisColorIndex % palette.length]}" d="${IconPathMap(icon)}"/></svg>
                                        <p>${t.name}</p>
                                    </div>
                                    <p class="tooltip-value">${t.data[params.dataIndex].toFixed(2)}</p>
                                </div>`,
                        ),
                     );
                     if (typeof params.data === "object" && params.data.at(1)) {
                        tooltipBody.append(
                           fromHTML(
                              `<div class="tooltip-row"><p>Magnitude</p><p class="tooltip-value">${params.data[1].toFixed(2)}</p></div>`,
                           ),
                        );
                     }
                  }
               });
               break;
            }
            case "boxplot": {
               tooltipHeader.append(
                  fromHTML(
                     `<div class="tooltip-row"><p><span class="tooltip-value">${params.name}</span></p><p>${params.seriesName}</p></div>`,
                  ),
               );
               tooltipHeader.setAttribute(
                  "style",
                  `border-bottom:${params.color} 2px solid`,
               );

               params.data.forEach((d, i) => {
                  if (i !== 0) {
                     tooltipBody.append(
                        fromHTML(`
                                <div class="tooltip-row">
                                    <div class="tooltip-row-identifier">
                                        <p>${boxLabels[i - 1]}</p>
                                    </div>
                                    <p class="tooltip-value">${d.toFixed(2)}</p>
                                </div>
                                `),
                     );
                  }
               });
            }
         }
         return tooltipContainer;
      },
   };
}
